import { useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { usePublishinRoyaltiesDetails } from "../hooks";
import { mapTypeGroup } from "../utils";
import { useFilteredRoyaltiesEarnings } from "./hooks";
import { RoyaltiesEarningsSorting } from "./models";
import RoyalatiesDetailsTableFilters from "./RoyalatiesDetailsTableFilters";
import RoyaltiesDetailsTablePresenter from "./RoyaltiesDetailsTablePresenter";

export default function RoyaltiesDetailsTableContainer() {
  const { data: publishingRoyaltiesDetails, isLoading } = usePublishinRoyaltiesDetails();
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');

  const [sortRoyaltiesBy, setSortRoyaltiesBy] = useState<RoyaltiesEarningsSorting>(RoyaltiesEarningsSorting.amountEarnedDesc);
  const [selectedPeriods, setSelectedPeriods] = useState<string[]>([]);
  const [selectedSources, setSelectedSources] = useState<string[]>([]);
  const [selectedSongs, setSelectedSongs] = useState<string[]>([]);

  const selectedTypeRoyalties = useMemo(() => publishingRoyaltiesDetails?.filter(x => mapTypeGroup(x.typeGroup) === type), [publishingRoyaltiesDetails, type]);

  const uniquePeriods = useMemo(() => [...new Set(selectedTypeRoyalties?.map(royalty => royalty.reportedOn) ?? [])], [selectedTypeRoyalties]);
  const uniqueSources = useMemo(() => [...new Set(selectedTypeRoyalties?.map(royalty => royalty.source) ?? [])], [selectedTypeRoyalties]);
  const uniqueSongs = useMemo(() => [...new Set(selectedTypeRoyalties?.map(royalty => royalty.songTitle) ?? [])], [selectedTypeRoyalties]);

  const filteredEarnings = useFilteredRoyaltiesEarnings(selectedTypeRoyalties, sortRoyaltiesBy, selectedPeriods, selectedSources, selectedSongs, type);

  return <>
    <RoyalatiesDetailsTableFilters
      sortRoyaltiesBy={sortRoyaltiesBy}
      setSortRoyaltiesBy={setSortRoyaltiesBy}

      selectedPeriods={selectedPeriods}
      setSelectedPeriods={setSelectedPeriods}
      uniquePeriods={uniquePeriods}

      selectedSources={selectedSources}
      setSelectedSources={setSelectedSources}
      uniqueSources={uniqueSources}

      selectedSongs={selectedSongs}
      setSelectedSongs={setSelectedSongs}
      uniqueSongs={uniqueSongs.filter(song => song !== null) as string[]}
    />
    <RoyaltiesDetailsTablePresenter
      data={filteredEarnings}
      isLoading={isLoading}
    />
  </>
}
